import { IWysiwygContent } from '~/types/generated/contentful'

import WysiwygContent from '../../section-modules/WysiwygContent/WysiwygContent'

export default function WysiwygContentModule({
  componentData,
}: {
  componentData: IWysiwygContent
}) {
  return <WysiwygContent content={componentData} />
}
